import React from 'react';
import { NavLink } from 'reactstrap';

function Footer(props) {
    return(
    <div className="footer">
        <div className="container">
            <div className="row justify-content-center py-3">             
                <div className="col-4 col-sm-2 text-center">
                    <h5>Links</h5>
                    <ul className="list-unstyled">
                        <li><NavLink href='/home'>Home</NavLink></li>
                        <li><NavLink href='/login'>Login</NavLink></li>
                    </ul>
                </div>
                <div className="col-7 col-sm-5">
                    <h5>Our Address</h5>
                    <address>
		              C-110, Lal Bahadur Shastri Hall of Residence, Indian Institute of Technology Kharagpur,
		              West Bengal, India - 731302
                    </address>
                </div>
                <div className="col-12 col-sm-4 align-self-center">
                    <div className="text-center">
                        <a className="btn btn-social-icon btn-facebook" href="http://www.facebook.com/srivastavan2812"><i className="fa fa-facebook"></i></a>
                        <a className="btn btn-social-icon btn-linkedin" href="http://www.linkedin.com/in/srivast-avan/"><i className="fa fa-linkedin"></i></a>
                        <a className="btn btn-social-icon btn-twitter" href="http://twitter.com/"><i className="fa fa-twitter"></i></a>
                        <a className="btn btn-social-icon btn-google" href="http://youtube.com/"><i className="fa fa-youtube"></i></a>
                        <a className="btn btn-social-icon" href="mailto:avaneesh2812@gmail.com"><i className="fa fa-envelope-o"></i></a>
                    </div>
                </div>
            </div>
            <div className="row justify-content-center">             
                <div className="col-auto">
                    <p>© Copyright 2023 Avaneesh Srivastava</p>
                </div>
            </div>
        </div>
    </div>
    )
}
export default Footer;